/**
 * Created by daniel on 02/05/17.
 */

import React, {Component} from 'react';
import ExportDialog from "./ExportDialog";
import {connect} from "react-redux";
import cheerio from 'cheerio';
import juice from 'juice/client';
import {getContentState, getRootItem} from "../../state/content/selectors";
import {setContentItems} from "../../state/content/actions";

class ExportDialogContainer extends Component {
  constructor(props) {
    super(props);
    this.handleRenderExport = this.handleRenderExport.bind(this);
    this.handleImportContent = this.handleImportContent.bind(this);
  }
  handleRenderExport() {
    // Looks for root item, throws it into cheerio, inlines styles with
    //debugger;
    let root = document.getElementsByClassName("root-table")[0];
    let content = root.outerHTML;
    
    // Remove redundant react comments
    let cleanContent = content.replace(/(<!--\sreact-empty:\s){1}([0-9]){1,5}(\s-->){1}/g, "");
    
    let inlinedContent = juice.juiceDocument(cheerio.load(cleanContent));
    
    // Remove hidden / placeholder elements
    inlinedContent(".editor-hidden").remove();
    inlinedContent(".placeholder").remove();
    
    let removableTags = {
      table: "table",
      tbody: "tbody",
      tr: "tr",
      td: "td",
    };
    
    // Remove redundant cells / rows
    function killEmpty(cheerioNode) {
      // Run on children if any
      let children = cheerioNode.children();
      children.each((i, o) => {
        if (o.tagName in removableTags) {
          killEmpty(inlinedContent(o))
        }
      });
      
      // Should we delete?
      if (cheerioNode.contents().length === 0) {
        cheerioNode.remove();
        console.log("Removed empty " + cheerioNode.get(0).tagName);
      }
    }
  
    killEmpty(inlinedContent(".root-table"));
    
    // Remove unnecessary attributes
    inlinedContent("*[draggable]").attr("draggable", null);
    
    // Extract text
    let html = inlinedContent.html();
    
    // Determine the template BG colour
    let bgcolor = this.props.rootItem.templateSettings.backgroundColor

    // Prepend header and footer
    let withHeaderFooter = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">\n' +
      '<html xmlns="http://www.w3.org/1999/xhtml">\n' +
      '<head>\n' +
      '<meta http-equiv="content-type" content="text/html; charset=utf-8" />\n' +
      '<style type="text/css">div, p, a, li, td { -webkit-text-size-adjust:none; }</style> \n' +
      '</head>\n' +
      `<body style="background-color:${bgcolor};">\n` +
      html +
      '\n</body>\n</html>';
    
    //debugger;
    // Removes newlines from document
    withHeaderFooter = withHeaderFooter.replace(/[\n\r]/g, "");
    //withHeaderFooter = withHeaderFooter.replace(/(.{77})/g, "$1\n");
    //withHeaderFooter = withHeaderFooter.replace(/(<(?:head|body|table|tbody|tr|td|ol|ul|li|br|p|h[1-6]|\/p|\/td)[^<]*>)/g, "$1\n");
    //withHeaderFooter = withHeaderFooter.replace(/(<.*?>)/g, "$1\n");
    //withHeaderFooter = withHeaderFooter.replace(/(<\/?(?:[^<]*>))/g, "$1\n");
    
    
    // Define Regex objects
    //let tagRegex = /<\/?[a-zA-Z]+[^>]*?(?:\s*\/)?>/g;
    let tagRegex = /(<\/?(?:head|body|table|tbody|tr|td|ol|ul|li|br|p|h[1-6])[^<]*>)/g;
    let attrRegex = /\s+[^\t\n\f />"'=]+="[^"]*"/g;
  
    withHeaderFooter = withHeaderFooter.replace(tagRegex, (match) => {
      return match.replace(attrRegex, (match) => "\n" + match) + "\n"
    });
  
    let warnings = "";

    let urlSpaceRegex = /href=(".+(\s|%20)")/;
  
    let lines = withHeaderFooter.split("\n");
    for (let i=0; i < lines.length; i++) {
      // Determine max line lengths
      if (lines[i].length > 1000) {
        warnings += `Line ${i+1} is longer than 1000 characters.\n`;
      }

      // Find any hyperlinks with a trailing space
      var testUrlSpaceRegex = urlSpaceRegex.test(lines[i]);
      if (testUrlSpaceRegex) {
        var execUrlSpaceRegex = urlSpaceRegex.exec(lines[i]);
        warnings += `Line ${i+1}:${execUrlSpaceRegex.index}: URL contains trailing whitespace: ${execUrlSpaceRegex[1]}\n`;
      }
    }


    
    return {
      original: content,
      inlined: withHeaderFooter,
      warnings: warnings
    };
  };
  
  handleImportContent(content) {
    this.props.dispatch(setContentItems(content))
  };
  
  render() {
    return (
      <ExportDialog
        open={this.props.open}
        visibility={this.props.handleVis}
        getHtml={this.handleRenderExport}
        currentState={this.props.currentState}
        importContent={this.handleImportContent}
      />
    );
  }
}

function mapStateToExports(state, ownProps) {
  return {
    open: ownProps.open,
    handleVis: ownProps.handleVisibility,
    currentState: getContentState(state),
    rootItem: getRootItem(state),
    state
  }
}

function mapDispatchToExports(dispatch) {
  return {
    dispatch
  }
}

export default connect(mapStateToExports, mapDispatchToExports)(ExportDialogContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ExportDialogContainer.js